import { Component } from '@angular/core';

@Component({
  selector: 'rms-breadcrumb',
  template: `<ng-content />`,
  host: {
    class:
      // eslint-disable-next-line
      'rms-breadcrumb body-2 text-hint leading-none hover:text-ruber no-underline transition duration-400 ease-out-swift',
  },
})
export class BreadcrumbComponent {}
